module.exports = __webpack_public_path__ + "static/media/refresh.bcd68b3e.svg";